(() => {
  if (window.ocBeadPaletteBound) return;
  window.ocBeadPaletteBound = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.bead-palette-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const status = form.querySelector('[role="status"]');
    const link = form.querySelector('.bead-palette-view');
    button.disabled = true;
    button.textContent = 'Adding…';
    status.hidden = true;
    link.hidden = true;
    const base = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(base + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:new FormData(form)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this set. Please try again.');
      status.textContent = 'Added to your bag.';
      status.hidden = false;
      link.hidden = false;
      try {
        const cartResponse = await fetch(base + 'cart.js', {headers:{Accept:'application/json'}});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
          document.querySelectorAll('a.bag').forEach(node => node.setAttribute('aria-label', 'Bag, ' + cart.item_count + ' items'));
        }
      } catch (_) { /* The item was added even if the count refresh fails. */ }
    } catch (error) {
      status.textContent = error.message || 'Unable to add this set. Please try again.';
      status.hidden = false;
    } finally {
      button.disabled = false;
      button.textContent = 'Add to bag';
    }
  });
})();
